<script>
    import { NotificationModal } from "../../../../../Components/Common/index.svelte";

    export let isModalOpen = false,
        defaultItems = [],
        selectedItems = [],
        addItem = () => {},
        closeModal = () => {};

    $: if (defaultItems.length) _syncProceduresByGroup();

    let selectedInfoGroup = "",
        displayItems = [];

    const groupOptions = [],
        procedureGroupMap = new Map();

    const closeSelector = () => {
        selectedInfoGroup = "";

        handleSelectGroup();

        closeModal();
    };

    const handleSelectGroup = () => {
        if (selectedInfoGroup)
            displayItems = procedureGroupMap.get(selectedInfoGroup);
        else displayItems = [];
    };

    // HELPER FUNCTIONS
    const _syncProceduresByGroup = () => {
        defaultItems.map((item) => {
            const { infoRegion } = item;
            const arr = infoRegion
                ? procedureGroupMap.has(infoRegion)
                    ? procedureGroupMap.get(infoRegion)
                    : []
                : procedureGroupMap.has("Other")
                ? procedureGroupMap.get("Other")
                : [];

            arr.push(item);

            procedureGroupMap.set(infoRegion ? infoRegion : "Other", arr);
        });

        procedureGroupMap.forEach((item, key) => {
            if (!groupOptions.includes(key)) groupOptions.push(key);
        });
    };
</script>

<NotificationModal
    {isModalOpen}
    title="Select additional procedures"
    closeModal={closeSelector}
    closeModalFunction={closeSelector}
    showConfirmBtn={false}
    noContentPadding
>
    <div class="flex flex-col gap-y-2 h-72 p-6">
        <div class="flex items-center gap-x-2">
            <select
                class="select select-sm select-bordered flex flex-1"
                bind:value={selectedInfoGroup}
                on:change={handleSelectGroup}
            >
                <option value="" selected disabled
                    >Select procedure group</option
                >
                {#each groupOptions as option}
                    <option value={option}>
                        {option}
                    </option>
                {/each}
            </select>
        </div>

        {#if !displayItems.length}
            <div class="flex flex-1 items-center justify-center text-lg">
                No possible items
            </div>
        {:else}
            <div class="flex flex-col flex-1 gap-y-1 overflow-y-auto">
                {#each displayItems as item}
                    <div
                        class="flex flex-1 items-center justify-between gap-x-4"
                    >
                        <div class="flex flex-col w-3/4">
                            <p class="text-xs">
                                {item.infoRegion}
                            </p>
                            <p class="text-md font-bold">
                                {item.infoShortTitle} ({item.amaUnits})
                            </p>
                        </div>

                        <button
                            class={`w-8 h-8 rounded-full text-[16px] text-[#fff] ${
                                selectedItems.some((itm) => itm.id == item.id)
                                    ? "bg-error"
                                    : "bg-secondary"
                            }`}
                            on:click|preventDefault={() => addItem(item)}
                        >
                            <i
                                class={`fa-solid ${
                                    selectedItems.some(
                                        (itm) => itm.id == item.id
                                    )
                                        ? "fa-minus"
                                        : "fa-plus"
                                }`}
                            />
                        </button>
                    </div>

                    <hr />
                {/each}
            </div>
        {/if}
    </div>
</NotificationModal>
